var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.25C8.3797 8.25 8.69349 8.53215 8.74315 8.89823L8.75 9V15C8.75 15.4142 8.41421 15.75 8 15.75C7.6203 15.75 7.30651 15.4678 7.25685 15.1018L7.25 15V9C7.25 8.58579 7.58579 8.25 8 8.25Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7432 8.89823C12.6935 8.53215 12.3797 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9V15L11.2568 15.1018C11.3065 15.4678 11.6203 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V9L12.7432 8.89823Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7449 2.44696C14.6666 1.22982 13.7019 0.25 12.5 0.25H7.5L7.34463 0.255496C6.16456 0.339294 5.25 1.37063 5.25 2.607V4.25H1L0.898229 4.25685C0.532154 4.30651 0.25 4.6203 0.25 5C0.25 5.41421 0.585786 5.75 1 5.75H2.25V16.5C2.25 18.2952 3.70479 19.75 5.5 19.75H14.5C16.2952 19.75 17.75 18.2952 17.75 16.5V5.75H19L19.1018 5.74315C19.4678 5.69349 19.75 5.3797 19.75 5C19.75 4.58579 19.4142 4.25 19 4.25H14.75V2.607L14.7449 2.44696ZM13.25 4.25H6.75V2.607L6.75605 2.49741C6.80389 2.06789 7.12913 1.75 7.5 1.75H12.5L12.5916 1.7565C12.9533 1.80805 13.25 2.1603 13.25 2.607V4.25ZM3.75 5.75H16.25V16.5C16.25 17.4668 15.4668 18.25 14.5 18.25H5.5L5.35643 18.2442C4.45685 18.1712 3.75 17.4184 3.75 16.5V5.75Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashWhite);
export default __webpack_public_path__ + "static/media/trash-white.222f486598808fcc0743ea4b5b4c3be1.svg";
export { ForwardRef as ReactComponent };